import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Empty Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M219.749 42.563 240.23 20.03c5.339-6.017 2.161-15.557-5.72-17.171a10.45 10.45 0 0 0-9.745 3.116l-20.482 22.52C127.766-30.272 16.325 15.832 3.691 111.48a125.33 125.33 0 0 0 32.56 101.857L15.77 235.87c-5.481 5.888-2.533 15.501 5.307 17.304a10.45 10.45 0 0 0 10.158-3.25l20.482-22.519c76.518 58.767 187.958 12.663 200.592-82.986a125.33 125.33 0 0 0-32.56-101.856M23.503 127.95c.048-80.442 87.16-130.666 156.8-90.403a105 105 0 0 1 9.873 6.479L50.411 197.806a104.01 104.01 0 0 1-26.908-69.856M128 232.447a103.9 103.9 0 0 1-62.176-20.572L205.589 58.094c53.826 59.712 22.826 155.301-55.8 172.06A104.4 104.4 0 0 1 128 232.446" }, null, -1)
  ])))
}
export default { render: render }